import { RotateProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { Icon, TabItem } from "@atoms/index"

import useTable from "@organisms/Table/Table.context"

import { TableViewPhaseProps } from "./TableViewPhase.types"

const icons = {
    active: {
        icon: faIcon({ name: "circle-minus", style: "regular" }),
        iconOnActive: faIcon({ name: "circle-minus", style: "solid" }),
        rotation: 90 as RotateProp,
    },
    inactive: {
        icon: faIcon({ name: "ban", style: "regular" }),
        iconOnActive: faIcon({ name: "ban", style: "solid" }),
        rotation: undefined,
    },
    open: {
        icon: faIcon({ name: "circle-dashed", style: "regular" }),
        iconOnActive: faIcon({ name: "circle-dashed", style: "solid" }),
        rotation: undefined,
    },
    closed: {
        icon: faIcon({ name: "box-archive", style: "regular" }),
        iconOnActive: faIcon({ name: "box-archive", style: "solid" }),
        rotation: undefined,
    },
}

export default function TableViewPhase(props: TableViewPhaseProps) {
    const { phase, title } = props

    const { setActivePhase, activePhase } = useTable()

    return (
        <TabItem
            iconInReactNode={
                <Icon
                    icon={icons[phase].icon}
                    iconOnActive={icons[phase].iconOnActive}
                    rotation={icons[phase].rotation}
                    isActive={phase === activePhase}
                    container="square"
                    size={14}
                />
            }
            isSelected={phase === activePhase}
            onClick={() => setActivePhase(phase)}
            noDebounce={true}
            title={title}
        />
    )
}
